module.exports = __webpack_public_path__ + "static/img/25.c82121d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/25.jpg
// module id = 6TAk
// module chunks = 16